import { memo } from 'react';

import type { KcContext } from 'keycloakify/login/KcContext';

import { Form } from 'src/shared/components/form/form.js';
import { Input } from 'src/shared/components/input/input.js';
import { useFieldMessage } from 'src/shared/hooks/use-field-message.js';
import { useFormValidator } from 'src/shared/hooks/use-form-validator.js';
import { useGetMsg } from 'src/shared/utils/kc-messages.js';

export interface LoginUpdateProfileProps {
    kcContext: KcContext.LoginUpdateProfile;
}

export const LoginUpdateProfile = memo<LoginUpdateProfileProps>(({ kcContext }) => {
    const { url, profile } = kcContext;

    const { msgStr, advancedMsgStr } = useGetMsg(kcContext);

    const firstNameError = useFieldMessage(['firstName'], kcContext);
    const lastNameError = useFieldMessage(['lastName'], kcContext);

    const [formErrors, resetFieldError, onSubmitValidated, submitDisabled] = useFormValidator(
        ['firstName', 'lastName'],
        {
            firstName: firstNameError,
            lastName: lastNameError,
        },
    );

    return (
        <Form
            title={msgStr('loginProfileTitle')}
            action={url.loginAction}
            kcContext={kcContext}
            onSubmit={onSubmitValidated}
        >
            <Input
                type="text"
                id="firstName"
                name="firstName"
                label={msgStr('firstName')}
                errorMessage={advancedMsgStr(formErrors['firstName'] ?? '')}
                onFocus={resetFieldError}
                defaultValue={profile?.attributesByName?.['firstName']?.value ?? ''}
                autoFocus={!firstNameError}
                required
            />

            <Input
                type="text"
                id="lastName"
                name="lastName"
                errorMessage={advancedMsgStr(formErrors['lastName'] ?? '')}
                label={msgStr('lastName')}
                onFocus={resetFieldError}
                defaultValue={profile?.attributesByName?.['lastName']?.value ?? ''}
                required
            />

            <Input type="submit" value={msgStr('loginProfileUpdate')} disabled={submitDisabled} />
        </Form>
    );
});
